<script>
/**
 * Navbar component
 */
export default {
  mounted: () => {
    window.onscroll = function() {
      onwindowScroll();
    };
    var navbar = document.getElementById("navbar");
    function onwindowScroll() {
      if (
        document.body.scrollTop > 40 ||
        document.documentElement.scrollTop > 40
      ) {
        navbar.style.backgroundColor = "#272a33";
        navbar.style.padding = "10px";
      } else {
        navbar.style.backgroundColor = "";
        navbar.style.padding = "10px";
      }
    }
  },
  methods: {
    /**
     * Toggle menu
     */
    toggleMenu() {
      document.getElementById("navbarCollapse").classList.toggle("show");
    }
  }
};
</script>
<style>
.logo > img {
  margin-top: -8px;
  height: 22px;
  width: auto;
}
</style>
<template>
  <!-- STRAT NAVBAR -->
  <nav
    class="navbar navbar-expand-lg fixed-top navbar-custom sticky sticky-dark"
    id="navbar"
  >
    <div class="container">
      <!-- LOGO -->
      <a
        class="navbar-brand logo text-uppercase"
        href="#"
        v-scroll-to="'#home'"
      >
        <img src="@/assets/images/logo-notagline.png" alt="" />
      </a>

      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarCollapse"
        aria-controls="navbarCollapse"
        aria-expanded="false"
        aria-label="Toggle navigation"
        @click="toggleMenu()"
      >
        <i class="mdi mdi-menu"></i>
      </button>
      <div class="collapse navbar-collapse" id="navbarCollapse">
        <ul
          class="nav navbar-nav ml-auto"
          id="mySidenav"
          v-scroll-spy-active="{ class: 'active' }"
        >
          <li class="nav-item">
            <a
              v-scroll-to="{ el: '#home' }"
              class="nav-link"
              data-scroll-spy-id="home"
              href="javascript: void(0);"
              >Home</a
            >
          </li>
          <li class="nav-item">
            <a
              v-scroll-to="{ el: '#features', offset: -50 }"
              class="nav-link"
              data-scroll-spy-id="features"
              href="javascript: void(0);"
              >Features</a
            >
          </li>
          <li class="nav-item">
            <a
              v-scroll-to="{ el: '#services', offset: -50 }"
              class="nav-link"
              data-scroll-spy-id="services"
              href="javascript: void(0);"
              >Services</a
            >
          </li>
          <li class="nav-item">
            <a
              v-scroll-to="{ el: '#contact', offset: -50 }"
              class="nav-link"
              data-scroll-spy-id="contact"
              href="javascript: void(0);"
              >Contact</a
            >
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <!-- END NAVBAR -->
</template>
